import {useContext} from "react";
import {DepotsContext} from "./DepotsContext";

export const useDepots = () => {
    const ctx = useContext(DepotsContext);
    if (!ctx) throw Error('You are not inside the provider');
    return ctx;
}
